import { BlogList } from "./BlogList/BlogList";
import SEO from "../../components/SEO"

export default function Blog({currentLanguage="en"}) {
    // SEO titles based on language
  const pageTitles = {
    en: "Blog",
    fr: "Blogues", // ✅ proper French word
  };

  const pageTitle = pageTitles[currentLanguage] || pageTitles.en;
  return (
    <>
        <SEO  title={pageTitle} />

      <BlogList currentLanguage={currentLanguage}/>
    </>
  );
}
